import { Component, Input } from '@angular/core';

@Component({
    selector: 'download-button',
    templateUrl: './download-button.component.html',
    styleUrls: ['./download-button.component.scss'],
    standalone: false
})
export class DownloadButtonComponent {
  @Input() downloadLink : string;
  @Input() buttonTitle: string = 'button_title';

  download() : void {
    window.open(this.downloadLink, '_blank');
  }
}
